<template lang="pug">
mixin legalSummary
  details.tos-summary
    summary
      span.tos-summary-title {{ summaryTitle }}
    .tos-summary-body
      p.tos-summary-note {{ summaryNote }}
      block

div
  h1 服务条款
  p
    | 使用本网站和使用 PandaFan 及其相关服务，即表示您同意受以下条款和条件约束。本条款适用于由 Beexio B.V. 及其附属子公司（以下合称「公司」）现在或未来向您的 PandaFan 账户提供的全部功能、内容和服务（以下统称「服务」）。
  p
    | 本条款的英文版本为正式版本。中文版本仅为方便阅读而提供；如中、英文版本存在差异，以英文版本为准。
  h2 关于公司
  p
    | 根据您的账户类型、所在地、账单信息、购买的服务类型及实际履约安排，为您提供服务的实体可能是本公司或公司的附属子公司。
  p
    | 本条款中的「公司」指实际为您提供服务的实体。最终为您提供服务的公司通常可根据您的付款记录、发票或账户页面中的账单信息确定。
  +legalSummary
    p 实际给你提供服务的主体，不一定永远都是同一个法人，可能会因你的地区、账单信息和购买内容而不同。
    p 想知道具体是哪家公司在履约，通常看付款记录、发票或账户页面上的账单信息就够了。
  h2 定义
  ul.list-disc
    li
      b 「服务」
      | 指公司向您提供的网络接入、配置、账户、客户端、线路信息、附属功能及相关支持，但不包含任何特定第三方网站、应用、媒体平台或地区内容的可访问性保证。
    li
      b 「核心服务」
      | 指在您的账户状态正常、付款与合规条件满足，且排除客户设备、网络环境或第三方平台因素后，您按所购套餐获得的基本服务使用资格，但不包含任何特定线路、地区、协议、IP 地址、第三方网站或媒体平台的持续可用性保证。
    li
      b 「账户」
      | 指您在 PandaFan 注册并用于购买、管理和使用服务的个人账户。
    li
      b 「线路」
      | 指服务中可供选择或自动分配的特定服务器、节点、入口或出口位置、协议、端口、IP 地址、路由或其组合。
    li
      b 「第三方服务」
      | 指并非由公司控制或运营的网站、应用、媒体平台、在线服务、应用商店、支付处理商或通信网络。
    li
      b 「促销奖励」
      | 指赠送时长、奖励余额、推荐奖励、折扣、半年付赠送的半个月、年付赠送的两个月或其他非用户额外付费直接购买的优惠权益。
  +legalSummary
    p 这一章是在定义后面会反复出现的关键词，后文看到这些词时，都按这里的意思理解。
    ul.list-disc
      li 「服务」不等于保证你一定能访问某个特定网站、App 或地区内容。
      li 「核心服务」指你买到的基本使用资格，不等于保证某条线路、某个 IP 或某个平台永远可用。
      li 「促销奖励」是赠送或优惠，不等同于你额外付费买下来的权益。
  h2 服务的用户与可用地区
  p
    | 本服务仅提供给年满 13 岁的个人，或已获得父母或法定监护人同意开立和维护账户的未成年人。本服务仅供个人使用。通过 BOT 程序或其他自动化方式注册的账户不被授权并可被终止。
  p
    | 每位用户均应对其账户及使用本服务的全部行为负责，并应确保其使用行为符合适用法律、本条款以及购买页面、帮助中心和账户页面展示的补充规则。
  p
    | 本服务仅在公司选择提供、且您的账单地址、支付方式、连接地区、合规要求、反滥用策略和运营条件允许的国家或地区内可供购买或使用。部分国家或地区可能被限制、拒绝提供、暂时不可用或仅能在满足额外条件时使用，包括但不限于部分东南亚国家或地区。可接受的账单国家/地区列表、受限连接地区列表及相关限制条件可能随时调整，并以您购买时、连接时或账户页面实际显示和校验结果为准。
  +legalSummary
    p 这项服务只给个人使用，机器人注册、批量注册或自动化注册都不行。
    p 哪些国家能买、能连、能继续用，不是固定不变的，会跟账单国家、支付方式、连接地区、风控和合规策略一起调整。
    p 你现在能不能买、能不能连，以购买时和连接时系统实际给出的结果为准。
  h2 使用政策和禁止行为
  p
    | 本服务不得用于荷兰法律、您所在地法律或其他适用法律所禁止的活动。为保护服务、用户和第三方不受误用、滥用或损害，公司会执行适用于所有用户的规则。您特别同意不将本服务用于以下用途：
  ul.list-disc
    li
      b 访问、分享、下载、上载非法内容，包括但不限于儿童色情或被认为属于儿童色情的内容；
    li
      b 基于性别、性取向、宗教、民族、种族、年龄、国籍或残疾的骚扰、辱骂、侮辱、伤害、诽谤、中伤、贬低、恐吓或歧视性内容；
    li
      b 使用本服务，通过电子邮件或任何其他通信渠道发送或传输未经请求的广告或内容（例如垃圾邮件）；
    li
      b 试图在未经适当授权的情况下访问、探测或连接计算机设备（即任何形式的黑客行为）；
    li
      b 侵害或侵犯本公司或他人的知识产权；
    li
      b 任何可能扰乱本服务的活动，例如爬虫、创建 TOR 节点或其他主要用于自动化程序的用途；
    li
      b 参与非法活动，或通过提供指导信息为他人从事非法活动提供手段或帮助；
    li
      b 滥用无限流量。在未经事先申请且获得同意的情况下，于一个计费周期（约一个月）内使用超过 500GB 的流量；
    li
      b 同时在线设备数量超出服务限定；
    li
      b 在非本人拥有使用权的设备上使用服务；
    li
      b 与同一屋檐下的家人之外的任何人共享账户或服务；
    li
      b 与多于 1 名同一屋檐下的家人共享账户或服务；
    li
      b 未经本公司许可将本服务用于任何商业目的。
  p
    | 如公司认为您参与、协助、组织或反复实施上述行为，公司可根据风险、严重程度和重复情况，采取提醒、限制、限速、软封禁、暂停、终止服务、删除账户、撤销促销奖励、拒绝恢复或其他必要措施。若您的行为给公司造成损失，您还可能需承担相关责任，包括任何外部实体就该等违规行为向公司收取的费用、律师费及相关成本。
  +legalSummary
    p 简单说，就是别拿服务去做违法、骚扰、攻击、滥用、倒卖、越权使用或共享转卖之类的事。
    p 违规不一定都是一刀切，但公司可以按情节轻重决定是提醒、限速、限制、停用还是直接终止。
    p 如果你的行为让公司被索赔、被罚或产生额外成本，这些损失可能要由你承担。
  h2 服务范围、兼容性与第三方限制
  p
    | 公司将尽商业上合理的努力维持服务可用，但服务范围、覆盖、速度、延迟、服务器位置、协议、质量、兼容性和可用功能可能因时间、地点、网络环境、运营策略和第三方条件而变化。服务不包含您对任何特定线路、地区、协议、IP 地址、端口、入口或出口位置的永久访问权。
  p
    | 您理解并同意，服务中的特定线路、地区、入口或出口位置、协议、端口、IP 地址、功能或资源数量，可能因网络环境、上游供应商调整、维护、合规要求、滥用防护、成本控制或业务决策而随时新增、减少、替换、迁移、限速、下线或暂时不可用。本公司不保证任何特定线路、地区、位置、协议或数量会持续提供或保持不变。只要服务的其他部分仍可正常使用，个别线路、地区或功能的调整、减少、替换、下线或暂时不可用，不当然构成整体服务不可用、违约、退款或赔偿事由。
  p
    | 第三方网站、应用、媒体平台或在线服务，可随时自行识别、限制、降级、拒绝、验证或封锁来自 IDC、云服务商、VPN、代理或共享出口 IP 的连接。本公司从未承诺、亦不保证能够绕过任何第三方限制，亦不保证您可持续访问、解锁或使用任何特定第三方服务、地区内容或功能，包括但不限于 Netflix。因第三方政策、版权要求、地理限制、反滥用机制、网络路径、账号风控或封锁措施而导致无法访问、无法解锁、画质下降、频繁验证、账号风控或体验不稳定的，不视为本服务存在缺陷，亦不构成退款或赔偿事由。
  p
    | 某些服务器、线路、地区或用户所在地，可能因当地政府、监管机关、电信运营商、审查制度、行政命令、网络封锁、强制干预或其他超出公司合理控制范围的措施，而出现封锁、干扰、限速、连接重置、流量劫持或无法连接的情况。对于该等不可抗或超出合理控制范围的情形，公司仅承诺尽商业上合理努力进行调整、修复、替代或减轻影响，但不对任何特定服务器、地区或用户所在地的绝对、持续或无条件可用性作出保证；由此导致的局部、地区性或个别用户不可用，不当然构成违约、退款或赔偿事由。
  p
    | 您有责任自行准备并维护可兼容的设备、操作系统、网络环境、应用商店账户、第三方客户端或公司提供/认可的客户端版本。公司可随时停止支持旧版客户端、旧版系统、旧版协议、特定第三方软件、特定导入方式或不再符合安全/合规要求的使用方式。
  +legalSummary
    p 我们会尽量让服务可用，但不会承诺某条线路、某个地区、某个协议、某个 IP 永远都在。
    p 如果只是局部线路变少、替换或暂时不可用，但其他线路还能正常用，一般不算整体服务故障。
    p 像 Netflix 这类第三方平台会主动封锁 IDC、VPN 或代理流量，这不在我们控制范围内，我们也不承诺一定能绕过。
    p 有些服务器、地区或个别用户可能会被当地政府、监管或运营商强力限制，这类情况公司只能尽力调整，不保证一定能恢复或持续可用。
    p 你的设备、系统版本、客户端和应用商店账号能不能兼容，也需要你自己准备和维护。
  h2 有限保证和责任
  p
    | 在适用法律允许的最大范围内，且在不影响任何不可放弃的法定消费者权利的前提下，本服务按「现状」和「可用时提供」基础提供。公司不就服务的可靠性、安全性、持续性、适销性、特定用途适用性、不中断性或无错误性作出任何保证。
  p
    | 对于您在使用本服务时访问、下载、接收或购买的任何数据、内容、服务或产品（包括软件），本公司不进行控制，也不承担责任。若因本服务的安全故障、漏洞、第三方系统问题或传输风险导致资料泄露、损坏、延迟、丢失、误传、无法送达或利润损失，在适用法律允许的范围内，公司不承担责任。
  p
    | 对于因本服务、通信服务、第三方平台、网络中断、性能问题、客户设备/资源问题、应用商店限制或其他第三方因素导致的数据、信息或页面丢失、无法发送、延迟、误传或无法使用，公司不承担责任。例如：因无法取得特定地区的 Apple ID、Google Play 账号、兼容客户端或第三方下载渠道而无法安装或使用应用。
  p
    | PandaFan 网站可能包含其他网站或资源的链接。公司对所链接网站、第三方服务或外部资源的内容、可用性、准确性、隐私政策及条款不承担责任。
  +legalSummary
    p 在法律允许范围内，服务是按“现状”和“可用时提供”提供的，不保证完全不断线、零错误或适合你所有用途。
    p 第三方平台、网络、设备、下载渠道或外部网站出问题，通常不由公司负责。
    p 但如果当地法律强制给消费者保留某些权利，这一章不会把那些权利拿掉。
  h2 账户限制、暂停、终止与申诉
  p
    | 为了安全、反欺诈、合规、支付争议处理、风险控制、服务稳定性或执行本条款，公司可随时对账户或服务采取提醒、要求解释、限制功能、限速、软封禁、暂停、终止、删除、拒绝开通、拒绝恢复或其他合理措施。
  p
    | 对于涉嫌欺诈、盗刷、拒付、严重滥用、共享倒卖、规避限制、法律风险、安全风险或其他紧急情况，公司可在不另行通知的情况下立即采取措施。对于非紧急或较轻微情形，公司通常可能会向您发送一次或多次通知、提醒或给予说明机会，但公司并不因此承担必须事先通知、必须警告特定次数或必须恢复服务的义务。
  p
    | 如您的账户或服务受到限制、暂停或终止，您可通过
    a(href='/dashboard/support') 帮助中心
    | 提交说明或申诉。公司可自行决定是否恢复、在何种条件下恢复、是否要求补充资料，以及是否维持、变更或撤销原处理结果。
  p
    | 作为恢复服务或恢复账户的条件之一，公司可撤销与账户相关的促销奖励、赠送时长、奖励余额、半年付赠送的半个月、年付赠送的两个月或其他优惠权益；在可行范围内，公司可保留用户已实际付费购买且未被该等促销权益覆盖的核心服务期限，但公司无义务恢复已被滥用、已消耗、已失效或已撤销的优惠权益。
  +legalSummary
    p 一般情况公司可能会先提醒、先沟通，也允许你申诉；但高风险或很严重的情况，可以先处理再说。
    p 是否恢复、怎么恢复、要不要补资料，最终还是由公司根据具体情况判断。
    p 如果账户后来被恢复，赠送时长、奖励余额，或半年付/年付附送的促销月份这类权益，可能不会一起恢复。
  h2 赔偿
  p
    | 在适用法律允许范围内，如因您使用本服务、违反本条款、违反法律、侵害第三方权利，或因您的账户、设备、行为、内容、支付争议或其他与您相关的事项引起任何第三方索赔、调查、损失、责任、罚款、成本或费用，您同意赔偿并使公司及其母公司、子公司、雇员、承包商和合作方免受损害，包括合理的律师费与执行成本。
  +legalSummary
    p 如果因为你的使用行为、违规行为或支付争议，导致第三方向公司追责或索赔，你可能需要承担由此带来的费用和损失。
  h2 隐私政策
  p
    a(href='/privacy-policy' title='PandaFan 的隐私政策') PandaFan 的隐私政策
    |  解释了本公司在您使用本服务时处理和保护您的个人数据和隐私的方式。一旦使用本服务，即表示您同意本条款和隐私政策。
  +legalSummary
    p 用服务时，除了这些条款外，隐私政策也同样适用。想知道公司怎么收集、使用和保护个人信息，请看隐私政策页面。
  h2 支付、服务期限与账单信息
  p
    | PandaFan 提供的服务通常为预付费服务，您支付的是所选服务时长、流量、套餐或其他明确列示的权益。除非购买页面另有明确说明，服务不会在到期时使用您过往的支付方式自动续费，亦不存在需要另行取消的自动续费订阅。
  p
    | 购买页面可就特定套餐提供含赠送时长的优惠价格。例如，半年付套餐可按 5.5 个月单月价格收费并额外赠送 0.5 个月服务，年付套餐可按 10 个月单月价格收费并额外赠送 2 个月服务。除购买页面另有明确说明外，该等赠送月份、折扣或额外时长均属于促销奖励，不属于用户以额外对价单独购买的服务期限，且不具有独立现金价值。
  p
    | 除购买页面另有说明外，服务期限通常在您的订单确认且相应服务被开通、续期、充值或加入您的账户时开始计算。公司可在支付确认、风控、账单核验、反欺诈或合规审查完成前暂缓开通、限制或撤销服务。
  p
    | 公司可要求您提供并维护真实、完整、可验证的账单地址、国家/地区及其他开票、税务、支付、反欺诈或合规所需信息。可接受的账单国家/地区、支付方式和税务处理方式可能随时变化。若发现使用被盗信用卡、虚假账单信息或其他欺诈性支付行为，公司有权立即停止服务并可将案件提交主管部门。
  p
    | 对于因支付争议、拒付、合规审查、涉嫌违规处理、账户限制、第三方平台限制或您自身原因导致的服务受限期间，是否补时、补偿或恢复，由公司根据适用法律和个案情况决定。
  +legalSummary
    p 这是预付费服务，默认不是自动续费；除非购买页明确写了，否则到期不会自动扣款续上。
    p 半年付只付 5.5 个月、年付只付 10 个月的那部分赠送月份，属于促销优惠，不是单独买下来的现金价值。
    p 服务时长通常从订单确认并且服务真正开通、续期或充值到账号时开始算。
    p 账单信息必须真实，支付争议、拒付、风控审查或违规处理期间，要不要补时或补偿，按个案处理。
  h2 法定消费者权利
  p
    | 本条款中的任何内容均不限制、排除或替代适用法律赋予消费者的不可放弃权利，包括但不限于法定撤回权、法定不符合约定救济、法定退款、法定减价、法定解除权或其他强制性消费者保护。
  p
    | 如适用法律对数字内容或数字服务规定了撤回权、合格性要求、修复/补救义务、减价或解除规则，则该等规则在其应适用的范围内继续适用。
  p
    | 如您在法定撤回期结束前，明确要求公司立即开始履行数字服务，并且公司在购买流程、订单确认或其他适当环节依法取得适用法律要求的同意、确认或承认，则您的法定撤回权可依适用法律被限制、缩减或消灭。
  +legalSummary
    p 如果当地法律强制给消费者保留某些权利，这份条款不会把这些权利写没。
    p 至于数字服务的撤回权会不会被限制，要看适用法律，也要看下单流程里是否依法取得了用户的明确同意和确认。
  h2 商业退款政策
  p
    | 下列商业退款政策系公司在法定权利之外额外提供的自愿性政策，不影响您在适用法律下可能享有的不可放弃权利。
  p
    | 因本公司过失导致您无法使用核心服务，您可在首次购买服务后的 24 小时内，且数据使用量不超过 100MB 的情况下，申请取消服务并退还服务费。不符合上述要求的退款申请可被考虑，但是否批准、批准范围和处理方式由公司全权决定。本公司仅有义务以原支付货币退款，退款通常将在申请后 30 天内处理。若要根据本商业退款政策申请退款，请通过
    a(href='/dashboard/support') 帮助中心
    | 联系我们。本条商业退款政策通常仅适用于通过 PandaFan 官方网站和客户端直接购买服务的用户；如您通过第三方处理商、中介或平台购买，请同时参考其各自的退款规则。
  p
    | 如您的购买包含促销奖励，例如半年付套餐按 5.5 个月单月价格收费并附送 0.5 个月服务，或年付套餐按 10 个月单月价格收费并附送 2 个月服务，则任何自愿性退款、按比例退款或残值计算，通常仅基于您实际支付对应的服务价值进行。公司可按实际已使用的服务时长乘以适用的单月价格计算已使用价值，并仅退还剩余的已支付价值（如有）；赠送月份、折扣或其他促销奖励不折算现金、不单独退款，亦不增加退款金额。
  p
    | 因您自身设备、资源、第三方平台、第三方客户端、应用商店账户、网络环境或其他非本公司过失因素导致无法使用本服务的退款申请可以被考虑，但由本公司全权决定。例如：无法取得非中国区 Apple ID、特定应用商店账户或兼容客户端。
  p
    | 在不限制前述约定的前提下，如服务的其他部分仍可正常使用，则下列情形通常不视为因本公司过失导致您无法使用服务：个别线路、地区、协议、端口、IP、功能或资源数量的调整、减少、替换、迁移、下线或暂时不可用；第三方网站、应用或平台对 IDC、云服务商、VPN、代理、共享出口 IP 或相关流量的识别、限制、降级、验证或封锁。
  p
    | 此外，因当地政府、监管机关、电信运营商、行政命令、网络封锁、审查制度、连接干预或其他超出公司合理控制范围的措施，导致某些服务器、地区、线路或个别用户无法连接、连接不稳定、被重置、被限速或无法正常使用服务的，通常亦不视为因本公司过失导致无法使用服务；相关退款申请是否受理及如何处理，由公司根据适用法律及个案情况决定。
  p
    | 如您选择使用第三方支付处理商、发卡机构、平台或银行提供的争议、拒付或退费机制，您将同意在该争议处理期间，公司可立即限制或暂停服务直至争议解决。此外，如争议、拒付或扣款机制的结果导致公司承担超过服务支付价格的费用、罚金或成本（例如争议手续费），在适用法律允许的范围内，公司可向您追偿该等金额。
  p
    | 公司亦可根据账户持有人的申请，自行决定按比例退还在服务不可用或无法使用期间已支付的服务费。支付处理机构收取的手续费、汇率差额、通道成本或不可退还的第三方费用，可在适用法律允许的范围内从退款金额中扣除。
  +legalSummary
    p 这一章说的是公司额外给出的商业退款规则，不是把你依法本来就有的权利替换掉。
    p 如果是公司原因导致核心服务确实没法用，首购后 24 小时内且用量不超过 100MB，可以按这套商业政策申请退款。
    p 半年付和年付里赠送的月份不折算成现金；退款时通常会按“已使用时长 × 单月价格”先算掉已用价值，再看还有没有残值可退。
    p 如果只是个别线路变动、第三方平台封锁、设备或账号环境不兼容，通常不按“公司故障”处理。
    p 如果问题主要来自当地政府、监管或运营商的强限制，一般也不按“公司过失”处理，只能按个案看是否有其他处理方式。
    p 走第三方拒付或争议流程时，服务可能先被限制，公司也可能追偿额外手续费。
  h2 推荐/促销奖励
  p
    | 推荐/促销奖励严格取决于供应情况和公司规则。被推荐人必须是此前从未购买过本服务的新用户。
  p
    | 推荐/促销奖励不可转让、不可协商、不可退还，且不可折算为现金。
  p
    | 为避免疑义，购买页面展示的半年付按 5.5 个月价格收费并赠送 0.5 个月、年付按 10 个月价格收费并赠送 2 个月等安排，其中赠送部分均属于推荐/促销奖励，而非用户以额外对价单独购买的服务时长。该等赠送部分可依本条款被撤销，且在退款、补偿、残值或折算计算中不单独计价。
  p
    | 如公司认定推荐人或用户存在欺诈、滥用促销、滥用服务、申请退款、拒付、共享倒卖或其他违反本条款的行为，公司可撤销全部或部分推荐/促销奖励，并可进一步限制相关账户。
  +legalSummary
    p 推荐和促销奖励只给符合规则的新用户场景，用完就算，不能当现金，也不能转给别人。
    p 半年付送半个月、年付送两个月这类优惠，本质上也属于促销奖励，违规、退款或恢复处理时都可能先被收回。
    p 如果有人刷奖励、滥用促销、退款或拒付，公司可以把奖励收回。
  h2 服务与条款的修改
  p
    | 在适用法律允许范围内，公司保留随时审查、修改、补充或更新本条款的权利。若变更对您构成重大不利影响，公司将在商业上可行的范围内，通过网站公告、账户页面、电子邮件或其他合理方式，于变更生效前或在紧急情况下于变更后尽快通知您。您在条款变更生效后继续使用本服务，即表示您同意该等变更。
  p
    | 公司保留自行决定修改服务的权利，例如增加、减少、替换、迁移或删除服务器、线路、地区、功能、协议、导入方式、支持范围、客户端能力、支付方式或软件更新。
  p
    | 为加强、保护和进一步发展本服务，公司可自行决定提供有限的技术支持、升级和更新，并可不时自动下载和安装更新或升级。作为您使用本服务的一部分，您同意接受此类更新和升级。
  p
    | 如因技术、法律、合规、安全、供应商、商业或运营原因，公司决定整体终止某项服务或整体停止向某类用户提供服务，公司将在商业上可行的范围内尽量提前通知，并在适用法律要求的范围内处理后续事宜。
  +legalSummary
    p 服务和条款都可能调整，包括线路、功能、协议、支付方式和支持范围。
    p 如果是对你影响比较大的不利变更，公司会尽量提前通知；紧急情况也可能先处理、后通知。
    p 某项服务如果因为技术、法律或商业原因整体下线，公司会在可行范围内做后续安排。
  h2 适用法律与争议解决
  p
    | 本条款及与本服务有关的争议，受荷兰法律管辖，但不包括其冲突规范；如您所在地的强制性消费者保护法律对您提供了不可放弃的额外保护，则该等保护不因本条款而被排除。
  p
    | 在适用法律允许的最大范围内，与本条款、本服务或双方争议有关的任何诉讼、争议或程序，应提交荷兰有管辖权的法院专属处理。
  +legalSummary
    p 发生争议时，默认按荷兰法律处理，法院也默认在荷兰。
    p 但如果你所在地法律强制保留某些消费者保护，这些强制性保护仍然有效。
  h2 其他
  ul.list-disc
    li
      b 可分割性：
      | 如本条款任何部分被认定为无效、违法或不可执行，不影响其余部分的效力。
    li
      b 不弃权：
      | 公司未立即行使任何权利或未立即执行任何条款，不构成对该权利或条款的放弃。
    li
      b 完整协议：
      | 本条款、隐私政策以及购买页面、账户页面或帮助中心明确引用的补充规则，共同构成您与公司之间关于本服务的完整协议。
    li
      b 转让：
      | 公司可因重组、融资、并购、资产转让或内部安排，将本条款项下的全部或部分权利义务转让、委托或移转给关联方或继受方。
  +legalSummary
    p 这一章是法律上的收尾条款，大意是：某一条就算失效，其他条款还继续有效；公司暂时没追究，不代表以后不能追究。
    p 条款、隐私政策和被明确引用的补充规则，一起构成完整约定；公司也可以在重组、并购或内部安排时把相关权利义务转给关联方或继受方。
</template>

<script setup lang="ts">
const summaryTitle = '简明说明 / 说人话版'
const summaryNote = '以下内容仅为便于理解的摘要，不替代本章正式条款；如摘要与正式条款有差异，以正式条款为准。'
</script>
